import * as React from 'react';

import { ProjectDiagramTileId } from 'src/constants/mosaic';
import { useContextMenu } from 'src/containers/ProjectDiagram/hooks/useContextMenuValue';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ProjectDiagramContainer } from 'src/containers/ProjectDiagram/ProjectDiagramContainer';

export const ProjectDiagramView = () => {
  const [contextMenu, setContextMenu] = useContextMenu();
  const diagram = useDiagram();

  return (
    <ProjectDiagramContainer
      contextMenu={contextMenu}
      id={ProjectDiagramTileId.VIEW}
      onContextMenuClose={() => {
        setContextMenu(null);
        // return focus to gojs
        diagram?.toolManager.contextMenuTool.doCancel();
      }}
    />
  );
};
